import { render, staticRenderFns } from "./AdaptativePlaceholderInput.vue?vue&type=template&id=51c93fc1&scoped=true&"
import script from "./AdaptativePlaceholderInput.vue?vue&type=script&lang=js&"
export * from "./AdaptativePlaceholderInput.vue?vue&type=script&lang=js&"
import style0 from "./AdaptativePlaceholderInput.vue?vue&type=style&index=0&id=51c93fc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c93fc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c93fc1')) {
      api.createRecord('51c93fc1', component.options)
    } else {
      api.reload('51c93fc1', component.options)
    }
    module.hot.accept("./AdaptativePlaceholderInput.vue?vue&type=template&id=51c93fc1&scoped=true&", function () {
      api.rerender('51c93fc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/components/AdaptativePlaceholderInput.vue"
export default component.exports